import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=a3d1843e&scoped=true&"
import script from "./notification.js?vue&type=script&lang=js&"
export * from "./notification.js?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./notification.css?vue&type=style&index=1&id=a3d1843e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d1843e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
